import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { api } from 'utils/axios';

const initialState = {
  step: 0,
  configs: {
    fee: '1.16',
    key: process.env.REACT_APP_GOOGLE_API_KEY,
    salesforce_status: false,
    status: false,
  },
  loading: false,
  resDjangoGoogleApi: null,
};

export const getConfigs = createAsyncThunk(
  'getConfigs',
  async (arg, { rejectWithValue }) => {
    const formData = new FormData();
    formData.append('name', 'Google Maps');
    formData.append('signature', process.env.REACT_APP_SIGNATURE);
    try {
      const response = await api.post('/get_api_key/', formData);

      return response.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

const globalSlice = createSlice({
  name: 'GlobalSlice',
  initialState,
  reducers: {
    nextStep(state, { payload }) {
      if (payload) {
        if (payload.feedback) {
          state.step = 20;
        } else if (payload.step) {
          state.step = payload.step;
        }
      } else {
        state.step = state.step + 1;
      }
    },
    prevStep(state, { payload }) {
      if (payload) {
        if (payload.feedback) {
          state.step = 4;
        } else if (payload.step) {
          state.step = payload.step;
        }
      } else {
        state.step = state.step - 1;
      }
    },

    fillDjangoGoogleApiData(state, { payload }) {
      state.resDjangoGoogleApi = payload;
    },
  },
  extraReducers: (builder) => {
    builder

      // Get Configs //
      .addCase('getConfigs/pending', (state) => {
        state.loading = true;
      })
      .addCase('getConfigs/fulfilled', (state, { payload }) => {
        state.loading = false;
        state.configs = payload;
      })
      .addCase('getConfigs/rejected', (state, { payload }) => {
        state.loading = false;
        console.error(payload);
      });
  },
});

export const { nextStep, prevStep, fillDjangoGoogleApiData } =
  globalSlice.actions;

export default globalSlice.reducer;
